export default "__VITE_ASSET__CpWHg4v0__"